import * as React from 'react';
import InputField from './InputField';
import { fetchBrregInfo, UserSetOrgnumber } from '../actions/Actions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { IOrganizationSearch, IState } from '../CustomTypes';
import { validateOrgnumber } from '../validators';

interface IOrganizationParamProps {
  formSubmitted?: boolean;
}

interface IOrganizationSearchDispatchProps {
  fetchBrregInfo: fetchBrregInfo;
  UserSetOrgnumber: UserSetOrgnumber;
}

interface IOrganizationSearchProps extends IOrganizationSearchDispatchProps {
  organizationData: IOrganizationSearch;
}

export interface IProps
  extends IOrganizationParamProps,
    IOrganizationSearchProps {}

class OrganizationSearch extends React.Component<IProps> {
  public render() {
    const { UserSetOrgnumber, organizationData, formSubmitted } = this.props;
    return (
      <InputField
        label="Organisasjonsnummer"
        placeholder="Skriv inn ditt organisasjonsnummer her"
        value={organizationData.input}
        type={'tel'}
        onBlur={this.searchBrreg}
        onChange={e =>
          UserSetOrgnumber(e.currentTarget.value.replace(/ /g, ''))
        }
        validator={validateOrgnumber}
        validationErrorMessage="Vennligst oppgi et gyldig organisasjonsnummer"
        formSubmitted={formSubmitted}
      />
    );
  }

  private searchBrreg = (e: any) => {
    this.props.fetchBrregInfo(this.props.organizationData.input);
  };
}

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      UserSetOrgnumber,
      fetchBrregInfo
    },
    dispatch
  ) as IOrganizationSearchDispatchProps;

export default connect(
  (state: IState) =>
    ({
      organizationData: state.organizationData
    } as IOrganizationSearchProps),
  mapDispatchToProps
)(OrganizationSearch);



// WEBPACK FOOTER //
// ./src/input-components/OrganizationSearch.tsx